module.exports = __webpack_public_path__ + "img/DireDawa_Certificate.9b562c0d.jpg";